import React from 'react';
import { Card, Checkbox, Grid, Stack, Typography } from '@mui/material';

type Props = {
    items: any[];
    allSelected: boolean;
    partiallySelected: boolean;
    onSetSelectedForGroup: (items: any[], checked: boolean) => void;
    renderCard: (subscriber: any) => React.ReactNode;
};

const SubscriberAnalyticsCardsSection = React.memo((props: Props) => {
    const { items, allSelected, partiallySelected, onSetSelectedForGroup, renderCard } = props;

    return (
        <>
            <Card sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5 }}>
                <Stack direction="row" spacing={0} alignItems="center">
                    <Typography variant="body2" color="textSecondary">
                        Select All
                    </Typography>
                    <Checkbox
                        checked={allSelected}
                        indeterminate={partiallySelected}
                        onChange={(_, checked) => onSetSelectedForGroup(items, checked)}
                        inputProps={{ 'aria-label': 'Select all subscribers in this group' }}
                    />
                </Stack>
            </Card>
            <Grid container spacing={1}>
                {items.map(renderCard)}
            </Grid>
        </>
    );
});

SubscriberAnalyticsCardsSection.displayName = 'SubscriberAnalyticsCardsSection';
export default SubscriberAnalyticsCardsSection;
